<div class="content">
  <div fxLayout="column" fxLayoutGap="5px">
    <div class="mark" fxLayout="column" fxLayoutGap="5px">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="headline">
          <h3 class="title">{{ markLabel }}</h3>
        </div>
        <ng-container *ngIf="isAdmin && !isOffline">
          <div fxLayoutAlign="end">
            <button mat-button color="primary" (click)="openEditMarksDialog()">
              <mat-icon class="text-icon" aria-label="">border_color</mat-icon>{{ "settingsMarkTitle.edit" | translate }}
            </button>
          </div>
        </ng-container>
      </div>
      <div>
        <mat-table #modeltable [dataSource]="markListDataSource" fxFlex>
          <ng-container matColumnDef="mark">
            <mat-header-cell *matHeaderCellDef>{{ markLabel }}</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.code }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="label">
            <mat-header-cell *matHeaderCellDef>{{ "settingsMarkTitle.label" | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.identifier }} - {{ row.label }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="color">
            <mat-header-cell *matHeaderCellDef>{{ "settingsMarkTitle.color" | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <mat-icon class="mark-icon" [style.color]="row.color">lens</mat-icon>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedMarkColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedMarkColumns"></mat-row>
        </mat-table>
      </div>
    </div>

    <div class="title" fxLayout="column" fxLayoutGap="5px">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="headline">
          <h3 class="title">{{ titleLabel }}</h3>
        </div>
        <ng-container *ngIf="isAdmin && !isOffline">
          <div fxLayoutAlign="end">
            <button mat-button color="primary" (click)="openEditTitlesDialog()">
              <mat-icon class="text-icon" aria-label="">border_color</mat-icon>{{ "settingsMarkTitle.edit" | translate }}
            </button>
          </div>
        </ng-container>
      </div>
      <div>
        <mat-table #modeltable [dataSource]="titleListDataSource" fxFlex>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>{{ titleLabel }}</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.identifier }} </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedTitleColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedTitleColumns"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
